<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <InfoDialogBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :pageData="pageData"
      :recItems="recItems"
      :isFooter="true"
      :isTotalAmount="false"
    >
    </InfoDialogBase>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import InfoDialogBase from './StorageAdjustInfoDialogBase'

// import NormalButton from '@/components/items/Buttons/NormalButton'
// import DialogAlertSuccess from '@/components/layouts/Dialogs/DialogAlert/DialogAlertSuccess'

import headers from '@/views/sales/History/headers'

export default {
  components: {
    InfoDialogBase

    // NormalButton,
    // DialogAlertSuccess
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    registerData: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    recItems: {},
    pageData: [],
    // completeDialog: false,
    remarks: {
      private: '',
      client: ''
    }
  }),
  created() {
    // this.init()
  },
  methods: {
    ...mapActions('Sale', ['registerSale']),

    init() {
      if (this.inputedValue.dialog) {
        const productMovesTmp = this.registerData.product.data.map(
          (ele, index) => {
            return {
              productMoveId: index,
              price: ele.price,
              quantity: ele.count,
              currencyId: ele.currencyId,
              exportSubjectFlg: ele.exportSubjectFlg,
              product: ele
            }
          }
        )

        this.recItems = {
          productMoves: productMovesTmp,
          client: this.registerData.client,
          totalList: this.registerData.totalList
        }
      }

      this.pageData = [
        {
          title: `${this.$t('storage.storage_stock-adjust-info')}（${
            this.registerData.client.clientInfo.name
          }）`,
          name: 'paymentInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'stock-adjust.stock-adjust_loading-stock-adjust',
          subTitle: 'stock-adjust.stock-adjust_increasing-stock',
          name: 'loading',
          headers: [
            {
              text: 'product.product_product-number',
              value: 'product.productNumber',
              sortable: false,
              width: '88px',
              align: 'center'
            },
            {
              text: 'common.product_product-name',
              value: 'productName',
              sortable: false,
              width: '235px'
            },
            {
              text: 'common.product_capacity',
              value: 'product.capacity',
              sortable: false,
              width: '50px',
              align: 'center'
            },
            {
              text: 'common.common_loading-quantity',
              value: 'quantity',
              sortable: false,
              width: '50px',
              align: 'center'
            },
            {
              text: 'loading.loading_loading-quantity-lot-number',
              value: 'quantityAndStorageNo',
              input: true,
              sortable: false,
              width: '222px',
              align: 'center'
            },
            {
              text: 'loading.loading_lot-number',
              value: 'productLotNumber',
              sortable: false,
              width: '100px',
              align: 'center'
            },
            {
              text: 'loading.loading_expiration-date',
              value: 'productExpiredDate',
              sortable: false,
              width: '125px',
              align: 'center'
            },
            {
              text: 'common.input_currency',
              value: 'productCurrency',
              sortable: false,
              width: '80px',
              align: 'center'
            },
            {
              text: 'sale.sale_price',
              value: 'productPrice',
              sortable: false,
              width: '80px',
              align: 'center'
            }
          ],
          items: [],
          footers: [],
          itemKey: 'product.productNumber'
        },
        {
          title: 'stock-adjust.stock-adjust_ship-stock-adjust',
          subTitle: 'storage.storage_when-reducing-stock',
          name: 'ship',
          headers: [
            {
              text: 'product.product_product-number',
              value: 'product.productNumber',
              sortable: false,
              width: '135px',
              align: 'center'
            },
            {
              text: 'common.product_product-name',
              value: 'productName',
              sortable: false,
              width: '360px'
            },
            {
              text: 'common.product_capacity',
              value: 'product.capacity',
              sortable: false,
              width: '88px',
              align: 'center'
            },
            {
              text: 'ship.ship_ship-quantity',
              value: 'quantity',
              sortable: false,
              width: '88px',
              align: 'center'
            },
            {
              text: 'ship.ship_stock-quantity-rack',
              value: 'quantityAndStorageNo',
              sortable: false,
              width: '140px',
              align: 'center',
              rowspan: false
            },
            {
              text: 'ship.ship_ship-quantity',
              value: 'count',
              sortable: false,
              width: '120px',
              align: 'center',
              rowspan: false
            }
          ],
          items: [],
          footers: [],
          itemKey: 'product.productId'
        },
        {
          title: 'sale.sale_note',
          name: 'test1',
          items: [],
          itemKey: ''
        }
      ]
    },
    async register() {
      // const isSuccess = await this.registerSale({
      //   clientData: this.registerData.client,
      //   registerProductList: this.registerData.product.data,
      //   totalList: this.registerData.totalList,
      //   privateRemarks: this.remarks.private,
      //   clientRemarks: this.remarks.client
      // })
      // if (isSuccess) {
      //   this.completeDialog = true
      // }
    }
    // editRemarks(...args) {
    //   const [remarks] = args
    //   this.remarks = {
    //     private: remarks.private,
    //     client: remarks.client
    //   }
    // }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.dialog) this.init()
      }
    }
    // completeDialog: function (newVal, oldVal) {
    //   if (!newVal && oldVal) {
    //     // TODO：在庫調整履歴画面へ遷移する
    //     this.$router.push({ name: 'sales.history' })
    //     this.inputedValue.dialog = false
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped></style>
